<form #LoginForm="ngForm" autocomplete="off" (submit)="login()">
  <div class="m-auto">
    <div class="p-grid">
      <div class="p-col-12">
        <h1 class="title">{{title}}</h1>
        @if (redirectMessage) {
          <p-message severity="info" [text]="redirectMessage"></p-message>
        }
        @if (firmtimeRedirectMessage) {
          <div [innerHTML]="firmtimeRedirectMessage"></div>
        }
        @if (firmtimeRedirectMessage2) {
          <div [innerHTML]="firmtimeRedirectMessage2" style="margin-top:20px;"></div>
        }
      </div>
      <div class="p-col-12">
        <label for="username">Email</label>
        <input class="form-control" name="username" type="text" [(ngModel)]="loginRequest.username" pInputText required>
      </div>
      <div class="p-col-12">
        <label for="password" class="m-top">Password</label>
        <input class="form-control" name="password" type="password" [(ngModel)]="loginRequest.password" pInputText required>
        <span class="forgotPassword">
          <a routerLink="/passwordReset" style="display: inline-block;">Need/Reset Password</a>
        </span>
      </div>
      <div class="p-col-6">
        <p-toggleswitch name="rememberMe" [(ngModel)]="rememberMe">
        </p-toggleswitch>
        <span class="remeberMeText">Remember Me</span>
      </div>
      <div class="p-col-6">
        <p-button type="submit" severity="success" label="Login" [style]="{'width': '100%'}" fluid class="login-button"
          [disabled]="!LoginForm.valid || isRequesting">
        </p-button>
      </div>
      @if (submissionError) {
        <p-message severity="error" text="Invalid login.">
        </p-message>
      }
    </div>
  </div>
</form>
